import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { config } from 'data/config'
import LegalInformationPage from 'layouts/LegalInformationPage'
import { PublicLayoutProps } from 'layouts/PublicLayout'

const PrivacyPolicyPage = () => {
  const router = useRouter()

  useEffect(() => {
    if (router.query?.section === 'user-account-information') {
      const element = document.getElementById('user-account-information')
      if (element) {
        element.scrollIntoView()
      }
    }
  }, [router])

  const seo: PublicLayoutProps['seo'] = {
    title: 'Privacy Policy for AMA Selections',
    description: 'Read our privacy policy page to find out more about our privacy policy, and our policy concerning the storage of information.',
    openGraph: {
      type: 'website',
      url: config.appURL + '/privacy-policy',
    },
  }

  return (
    <LegalInformationPage
      seo={seo}
      title="Privacy Policy"
      termlyId="d9049d8c-6254-434b-b223-6f20bcb79414"
    />
  )
}

export default PrivacyPolicyPage
